import styled from 'styled-components';
import ChevronUp from '@assets/icons/svgs/ChevronUp';
import ChevronDown from '@assets/icons/svgs/ChevronDown';
import React from 'react';

export const CollapseButtonIconWrapper = styled.div`
  padding-bottom: 8px;
  cursor: pointer;

  svg {
    height: 24px;
    width: 24px;

    fill: ${({ theme }) => theme.themeColors.text};
  }
`;

export const CollapseButton = ({ isCollapsed, setCollapsed }) => {
  if (isCollapsed) {
    return (
      <CollapseButtonIconWrapper onClick={() => setCollapsed(false)}>
        <ChevronDown />
      </CollapseButtonIconWrapper>
    );
  } else {
    return (
      <CollapseButtonIconWrapper onClick={() => setCollapsed(true)}>
        <ChevronUp />
      </CollapseButtonIconWrapper>
    );
  }
};
